module.exports = __webpack_public_path__ + "static/img/newanli-13.a54d61dc.jpg";